import React from 'react';
import style from './critical-error.module.scss';

/* eslint-disable-next-line */
export interface CriticalErrorProps {}

export function CriticalError(props: CriticalErrorProps) {
    return (
        <div className={`${style['critical-error-page']}`}>
            <div className={style["separator"]}></div>
            <div className={style["error-details"]}>
                <img className={style["error-icon"]} src='/assets/icon_warning.svg' alt='warning' />
                <div className={style["title"]}>
                    Oops! There was an internal server error.
                </div>
                <div className={style["description"]}>
                    <div>Sorry, there we’re some technical issues while processing your request. In the meantime,</div>
                    <div>you can wait a few minutes or refresh your page. Sorry for the inconvenience.</div>
                </div>
            </div>
        </div>
    );
}

export default CriticalError;
